import { UpperSectionProps } from "../@types/AppTypes";
import { useSelector } from "react-redux";
import { RootState } from "../core/store";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import duration from "dayjs/plugin/duration";
import "dayjs/locale/pt-br";
import JackpotCard from "../components/jackpotCards/JackpotCard";
import TopMenu from "./TopMenu";
import { useQuery } from "@tanstack/react-query";
import { getProfile } from "../lib/react-query/queryFunctions";
import { useState } from "react";
import { SignIn } from "@phosphor-icons/react";

export function padWithZeros(number: number, minLength: number) {
  const numberString = number.toString();
  if (numberString.length >= minLength) return numberString;
  return "0".repeat(minLength - numberString.length) + numberString;
}

export default function UpperSection({
  refetchJackpots,
  refetchResults,
  setOpenCheckoutModal,
  setOpenParticipantsModal,
}: UpperSectionProps) {
  dayjs.extend(utc);
  dayjs.extend(timezone);
  dayjs.extend(duration);
  const [openMyTicketsModal, setOpenMyTicketsModal] = useState(false);
  const jackpots = useSelector(
    (state: RootState) => state.jackpots.openJackpot
  );
  const jackpotParticipants = useSelector(
    (state: RootState) => state.jackpots.openJackpotParticipants
  );
  const authToken = localStorage.getItem("authToken");
  const { data: Profile, refetch: refetchProfile } = useQuery({
    queryKey: ["getProfile", authToken],
    queryFn: getProfile,
    enabled: authToken ? true : false,
  });

  return (
    <section className="flex flex-col w-full pb-10 items-center justify-center  bg-[url('/public/header_1024.png')] xl:bg-[url('/public/background.png')] bg-cover lg:scrollbarLG">
      {authToken && (
        <TopMenu
          profile={Profile}
          openMyTicketsModal={openMyTicketsModal}
          setOpenMyTicketsModal={setOpenMyTicketsModal}
        />
      )}
      <div className="flex flex-col lg:flex-row w-full items-center justify-center pt-4 lg:pt-10 lg:pb-20 gap-6 lg:gap-12">
        <div className="flex flex-col  min-w-[360px] lg:min-w-[480px] items-center justify-center text-white uppercase text-center">
          <img
            src={"/lotopix.png"}
            alt="Logo"
            className="w-[231px] h-[252px] lg:w-[462px] lg:h-[504px]"
          />
          <p className="hidden lg:block max-w-[480px] font-extrabold text-4xl">
            Muito mais<br></br>chances de ganhar!
          </p>
          <p className="text-white uppercase tracking-[2px] text-xs lg:text-base mt-2 lg:mt-1">
            Sorteios toda hora!
          </p>

          {/*!authToken && (
            <button
              type="button"
              className="flex flex-row gap-3 px-8 py-3 mt-4 rounded-full bg-[#C4FA00] hover:bg-[#C4FA00]/90 text-[#002F13]"
            >
              <SignIn className="w-6 h-6" />
              <span className="font-medium text-[18px] leading-[21.8px]">
                Entrar
              </span>
            </button>
          )*/}
        </div>

        {jackpots != null && (
          <JackpotCard
            refetchJackpots={refetchJackpots}
            refetchResults={refetchResults}
            refetchProfile={refetchProfile}
            profile={Profile}
            jackpotArray={jackpots!}
            jackpotParticipants={jackpotParticipants}
            setOpenMyTicketsModal={setOpenMyTicketsModal}
            setOpenCheckoutModal={setOpenCheckoutModal}
            setOpenParticipantsModal={setOpenParticipantsModal}
          />
        )}
      </div>
    </section>
  );
}
